import { Box, Button, Stack, TextField, Typography } from "@mui/material";
import { useState } from "react";
import * as Yup from "yup";
import { useFormik } from "formik";
import LoadingButton from "@mui/lab/LoadingButton";

function AdminPass(props) {
    const {open, submitForm} = props

    const [ isLoading,setIsLoading] = useState(false)

  const formikForm = useFormik({
    initialValues: {
      passWord: "",
    },
    validationSchema: Yup.object({
      passWord: Yup.string()
        .required("Required")
        .min(8, "must be more than 8 characters"),
    }),
    onSubmit: (values) => {
      setIsLoading(true)
    passWordChecker(values)
        
    },
  });

  const passWordChecker = async (pass_word) => {
    
    const response = await fetch("http://127.0.0.1:8000/messenger/passanalysis/", {
      mode: "cors",
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: new URLSearchParams(pass_word),
    });
    const fetcher = response.body.getReader();
    let data = [];
    let receivedLength = 0;
    while (true) {
      const { value, done } = await fetcher.read();

      if (done) {
        break;
      }

      data.push(value);
      receivedLength += value.length;
    }
    let chunksAll = new Uint8Array(receivedLength);
    let position = 0;
    for (let chunk of data) {
      chunksAll.set(chunk, position);
      position += chunk.length;
    }
    let result = new TextDecoder("utf-8").decode(chunksAll);

    let finalData = JSON.parse(result);
    if(finalData===true){
      setIsLoading(false)
      open(false)
      submitForm()
    }else{
      setIsLoading(false)
      formikForm.errors.passWord='Wrong Password'
    }
    
  };

  return (
    <>
      <form onSubmit={formikForm.handleSubmit}>
        <Stack rowGap={2} padding={3} width={"30vw"}>
          <Typography>Admin Password Required</Typography>
          <Stack display={'flex'}>
            <TextField
              label="Admin Password"
              size="small"
              type="password"
              id="passWord"
              name="passWord"
              value={formikForm.values.passWord}
              fullWidth
              onChange={formikForm.handleChange}
            />
            {formikForm.touched.passWord && formikForm.errors.passWord ? <Typography color="error">{formikForm.errors.passWord}</Typography>:null}
          </Stack>

          <Box display={"flex"} justifyContent={"center"}>
            <LoadingButton type="submit" loading={isLoading}>Submit</LoadingButton>
          </Box>
        </Stack>
      </form>
    </>
  );
}

export default AdminPass;
